/**
 * 商品グリッド(無限スクロール)の読み込み中に3点バウンドインジケーターを表示する。
 * コア機能(@theme/paginated-list, assets/results-list.js)は編集せず、
 * 同じ監視対象(viewMoreNext)を外側から独自に観測して表示/非表示だけを担当する。
 */

/**
 * @param {Element} grid
 * @returns {boolean}
 */
function hasMorePages(grid) {
  const cards = grid.querySelectorAll(':scope > [ref="cards[]"]');
  const lastCard = cards[cards.length - 1];
  const currentPage = Number(lastCard?.getAttribute('data-page') ?? '1');
  const lastPage = Number(/** @type {HTMLElement} */ (grid).dataset.lastPage ?? '1');
  return currentPage < lastPage;
}

/**
 * @param {Element} list
 */
function initGridLoadingIndicator(list) {
  const sentinel = list.querySelector('[ref="viewMoreNext"]');
  const grid = list.querySelector('[ref="grid"]');
  const indicator = list.querySelector('.ts-grid-loading');
  if (!sentinel || !grid || !indicator) return;

  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.target !== sentinel) continue;
        indicator.classList.toggle('is-visible', entry.isIntersecting && hasMorePages(grid));
      }
    },
    { rootMargin: '100px' }
  );
  intersectionObserver.observe(sentinel);

  const mutationObserver = new MutationObserver((mutations) => {
    const added = mutations.some((mutation) => mutation.addedNodes.length > 0);
    if (added) indicator.classList.remove('is-visible');
  });
  mutationObserver.observe(grid, { childList: true });
}

document.querySelectorAll('results-list').forEach(initGridLoadingIndicator);
